import 'css-chunk:src/app/containers/Home/UsersView/UserDetailView.scss';export default {
  "UserDetailView": "_UserDetailView_1sa7i_2",
  "header": "_header_1sa7i_2",
  "action": "_action_1sa7i_7",
  "children": "_children_1sa7i_10",
  "menu": "_menu_1sa7i_10"
};